// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueAWN from 'vue-awesome-notifications'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import { round } from 'lodash'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import i18n from './i18n/index'
// import moment from 'moment'

import App from './App'
// import mock from './mocks';
import router from './router'
import store from './store'
import config from './config'

import Modal from './components/Modal'
import Datatable from './components/Datatable'
import InputField from './components/InputField'
import InputText from './components/InputText'
import InputNumber from './components/InputNumber'
import GarmentConfig from './components/GarmentConfig'
import GarmentConfig2 from './components/GarmentConfig2'
import PopupModal from './components/PopupModal'
import VerticalTable from './components/VerticalTable'
import ERPModal from './components/ERPModal'
import ProductStatusModal from './components/ProductStatusModal'
import OrderView from './components/OrderView'
import Tree from './components/Tree'
import Branch from './components/Branch'
import Pagination from './components/Pagination'

import 'vue-awesome-notifications/dist/styles/style.css'
import 'semantic-ui/dist/semantic.min.css'
import './assets/style.css'
// import 'semantic-ui/dist/semantic.min.js';
// require('../semantic/dist/semantic.css');
// require('../semantic/dist/semantic.js');

/**
 * Dialog
 */
const awnOptions = {
  labels: {
    confirm: ''
  }
}
Vue.use(VueAWN, awnOptions)

/**
 * Vue configuration
 */
Vue.config.performance = true
Vue.config.productionTip = false

/**
 * Axios config
 */
axios.defaults.baseURL = config.server.url
axios.interceptors.request.use(
  (cfg) => {
    store.dispatch('setLoading', true)
    return cfg
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (response) => {
    store.dispatch('setLoading', false)
    return response
  },
  (error) => {
    store.dispatch('setLoading', false)
    // eslint-disable-next-line
    console.log(error)

    if(!error.response) {
      Vue.prototype.$awn.warning('Whoops, something went wrong')
      return Promise.reject(error)
    }

    if (error.response.data && error.response.data.disableGlobal) {
      return Promise.reject(error)
    }

    switch (error.response.status) {
      case 500: {
        Vue.prototype.$awn.warning('Whoops, something went wrong')
        break
      }
      case 400: {
        Vue.prototype.$awn.warning(error.response.data.error)
        break
      }
      case 422: {
        const { errors } = error.response.data
        Object.keys(errors).forEach((key) => {
          Vue.prototype.$awn.warning(errors[key])
        })
        break
      }
      case 401: {
        store.dispatch('logout')
        break
      }
      default: {
        Vue.prototype.$awn.warning('Whoops, something went wrong')
      }
    }
    return Promise.reject(error)
  }
)

/**
 * Validator
 */
Vue.use(VeeValidate)

/**
 * Load components
 */
Vue.component('modal', Modal)
Vue.component('datatable', Datatable)
Vue.component('input-field', InputField)
Vue.component('input-text', InputText)
Vue.component('input-number', InputNumber)
Vue.component('garment-config', GarmentConfig)
Vue.component('garment-config-2', GarmentConfig2)
Vue.component('popup-modal', PopupModal)
Vue.component('vertical-table', VerticalTable)
Vue.component('erp-modal', ERPModal)
Vue.component('order-view', OrderView)
Vue.component('tree', Tree)
Vue.component('branch', Branch)
Vue.component('pagination', Pagination)
Vue.component('product-status-modal', ProductStatusModal)

/**
 * Filters
 */
Vue.filter('price', (value) => {
  if(!value) return ''
  const roundedValue = round(value, 0)
  return `${roundedValue} €`
})

Vue.filter('formatProductName', (value) => {
  if(!value) return value
  return value.replaceAll(',', ",<br/>").replaceAll('-', '<br/>')
})

/**
 * Enable Sentry
 */
if (process.env === 'production') {
  Sentry.init({
    dsn: 'https://2ecd5fd1af994fa6bb42b3ae2e471b2a@sentry.aliengen.com/24',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}

/**
 * Init VueJS.
 */
// eslint-disable-next-line
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})

store.dispatch('checkAuth')



// WEBPACK FOOTER //
// ./src/main.js